import { images } from "../assets/images";

export const servicesData = [
  {
    key: "seo",
    icon: "SEO",
    title: "Search Engine Optimization (SEO)",
    image: images.services.seo,
    headline: "Best SEO Agency for Organic Growth of Your Business",
    intro: "Are you fed up with SEO agencies that make empty promises? We don't do things like that at Ad Hawk Technologies. We increase your ranking on Google, bring in the correct audience, and turn organic traffic into actual measurable sales — not vanity sales.",
    description: [
      "We don't believe in cookie-cutter strategies. We get to know your business, your customers, and your objectives before we ever put our fingers on a single keyword. After that, we create a personalized SEO strategy roadmap that really gets things done.",
      "As a scrappy start-up, as a local service provider, and as a growing eCommerce brand, we're all about what really matters: higher rankings, quality leads, and sustainable long-term growth."
    ],
    content: [
      { type: "h3", text: "Ad Hawk Technologies: Why Is It the SEO Partner You Should Choose?" },
      { type: "p", text: "In fact, there are a lot of SEO agencies, but not many can deliver results. What makes us unique:" },
      { type: "ul", items: [
        "Data-driven strategies—All decisions are based on results and not on guesswork.",
        "Quality traffic – over empty numbers, we aim to get visitors who are ready to buy.",
        "We target keywords to bring real customers, not clicks.",
        "We can handle the technical depth, as well as creative execution.",
        "Complete transparency—you will never be kept in the dark and will always know what we are doing and why it is working."
      ] },
      { type: "p", text: "We assist you to grow organically, consistently, and for the long term." },

      { type: "h3", text: "Our SEO Services" },

      { type: "h4", text: "On-Page SEO" },
      { type: "p", text: "Your website is your virtual storefront—and first impressions are everything. We optimize all your visitors' and search engines' views, such as:" },
      { type: "ul", items: [
        "Optimization of content for targeted and high-intent keywords",
        "Optimized internal links and SEO-friendly URLs.",
        "To improve the speed of the pages loading, images are compressed.",
        "Crafting compelling meta titles, meta descriptions, and structured data markup."
      ] },
      { type: "p", text: "The result: improved search rankings, user experience, and on-page engagement." },

      { type: "h4", text: "Off-Page SEO" },
      { type: "p", text: "Great SEO doesn't just end at your website. We help establish your brand's authority and reputation on the web via:" },
      { type: "ul", items: [
        "Quality backlinks with good authority, or white-hat links.",
        "Guest posting on relevant and authoritative websites.",
        "Make sure that business directory listings and consistent NAP citations are in place. Ensure business directory listings and consistent NAP citations are in place.",
        "Strategic social bookmarking"
      ] },
      { type: "p", text: "The result: An improved domain authority and more credibility with Google." },

      { type: "h4", text: "Technical SEO" },
      { type: "p", text: "There is a strong technical underpinning behind every high-ranking website. We audit, fix, and optimize:" },
      { type: "ul", items: [
        "The structure of the website and how it is crawled.",
        "XML sitemaps and indexing settings",
        "Core Web Vitals performance and page speed.",
        "Mobile Responsiveness and Site Health overall."
      ] },
      { type: "p", text: "The result: A faster, cleaner, and search engine-optimized website." },

      { type: "h4", text: "Local SEO" },
      { type: "p", text: "Desire to be found by local customers before your competitors? It's all about local SEO. We help you:" },
      { type: "ul", items: [
        "Get into Google's coveted Local 3-Pack.",
        "Make sure that your Google Business Profile is optimized for visibility.",
        "Focus on keywords that are relevant to the location and have a high conversion rate.",
        "Increase foot traffic, phone calls, and local leads."
      ] },
      { type: "p", text: "The result: Increased foot traffic and phone calls to your business." },

      { type: "h4", text: "E-commerce SEO" },
      { type: "p", text: "Do you have an online business? We get your products in front of shoppers who are ready to buy. Our eCommerce SEO strategy consists of:" },
      { type: "ul", items: [
        "Product and category page optimization. Optimization of product and category pages.",
        "Buyer-intent keyword research and targeting",
        "Product descriptions that are both SEO-friendly and convert.",
        "Structured data for rich results in Google Shopping."
      ] },
      { type: "p", text: "The result: increased product visibility, improved conversion rates, and increased sales." },

      { type: "h4", text: "Mobile SEO" },
      { type: "p", text: "Google is mobile-first, and over 50% of all traffic to the web is now from a mobile device. We ensure your website looks great on all screens by:" },
      { type: "ul", items: [
        "The design and optimization of websites for mobile devices. Design and optimization for mobile devices.",
        "Quick load times on all devices",
        "A responsive design and simple navigation system. Responsive design and easy navigation."
      ] },
      { type: "p", text: "The result: Improved mobile rankings and a smooth visitor journey for your mobile users." },

      { type: "h4", text: "Small Business SEO" },
      { type: "p", text: "Limited budget? This is not a restriction; it's a challenge we're excited about. We create a lean, high-impact SEO strategy that is tailored for small businesses:" },
      { type: "ul", items: [
        "Targeting specific, niche keywords,",
        "Local SEO for your local market. Local SEO for your local market.",
        "Tactics that are cost-effective and have a high return on investment without a Fortune 500 budget."
      ] },
      { type: "p", text: "The result: The highest possible return on investment, even on a modest budget." },

      { type: "h4", text: "Video SEO" },
      { type: "p", text: "Video is one of the most effective types of content on the internet—if people can find it. We optimize your videos to help them appear in YouTube search results and Google search results, including:" },
      { type: "ul", items: [
        "Titles, descriptions, and transcripts with keywords targeted.",
        "Video tags and personalized thumbnails for improved click-through rates.",
        "Channel authority and engagement signals"
      ] },
      { type: "p", text: "The result: increased views, brand awareness, and organic reach." },

      { type: "h3", text: "What is the consequence of neglecting SEO? (6 Costly Consequences)" },
      { type: "p", text: "It may sound like a quick fix to forego SEO, but it's like grinding away at your business growth without realizing it. What's at stake:" },
      { type: "ol", items: [
        "Your Business Becomes Invisible Online—It is impossible to be on page one if your site is not optimized. The truth is, most people don't even click on the second page of search results. If there's no visibility, there's no traffic—it's as simple as that.",
        "Your Competitors Look More Credible — People naturally believe businesses that are ranked higher. Your competitor is ranked higher than you, and they instantly seem more authoritative, even if your product or service is better.",
        "You're Losing Out on Customers Every Day—Right? Now, prospects are looking for what you have to offer. If you don't have SEO, you're not appearing—and someone else is taking your business.",
        "You'll End Up Spending More on Paid Ads—If there's no organic traffic, then you have to pay for ads. Ads are ok, but if they are the only way to make money, they are too costly and will not work in the long run.",
        "Your Brand Remains Anonymous—These are some of the most effective ways to build brand awareness through consistent organic visibility. If not, you are just not in front of people when it counts!",
        "Your competitors are investing in SEO now—your competitors are investing in SEO now. Each day they're making progress without it—and your potential customers are making progress with them."
      ] },

      { type: "h3", text: "We have an established SEO process that we follow." },
      { type: "p", text: "We have a well-planned and research-backed process for creating all campaigns:" },
      { type: "ul", items: [
        "Business Research & Current State Assessment — Our initial step is to get to know your business inside and out.",
        "Website SEO Audit—Complete a technical and content audit to see what's blocking you.",
        "Market Research—We research and understand what your competitors are doing to be successful, and we find the opportunity to do better.",
        "Keyword & Audience Research — Identifying the specific keywords that your target audience is searching for.",
        "On-Page, Technical, and Off-Page Strategy Development—A specific strategy that is created on the page, technically, and off the page based on your objectives.",
        "On-Page SEO Implementation — Optimizing your content, structure, and metadata",
        "Technical & Off-Page SEO Execution — Addressing back-end problems and establishing authority.",
        "Performance Monitoring — Monitoring results against clearly agreed targets",
        "Reporting & Analysis — Clear, complete reporting and analysis that lets you know your ROI at all times"
      ] },

      { type: "h3", text: "Looking to grow your business organically?" },
      { type: "p", text: "We're not chasing rankings at Ad Hawk Technologies; we're creating digital authority that makes an impact on business." },
      { type: "p", text: "When you want to be higher in Google search results, quality visitors, regular leads, and sustainable revenue growth, it's time to work with an actual SEO company that's dedicated to your success." },
      { type: "p", text: "Let's talk. Your growth starts here." }
    ],
    offers: [
      "Thorough keyword research, understanding user intent.",
      "On-page optimization (meta tags, headings, content optimization)",
      "Optimizing your site for search engines means ensuring it loads quickly, is mobile-friendly, and doesn't have any indexing problems. Technical SEO (site speed, mobile, indexing)",
      "High-quality backlink building",
      "Local SEO for businesses in specific areas.",
      "Competitor analysis & SEO audits"
    ],
    benefits: ["Higher Google rankings", "Increased organic traffic", "Better user experience", "Long-term ROI"],
  },
  {
    key: "ppc",
    icon: "PPC",
    title: "Pay-Per-Click Advertising (PPC)",
    image: images.services.ppc,

    headline: "Performance Marketing Agency is the solution that can help you get instant results and high-quality leads.",
    intro: "PPC advertising works as soon as it's done, and it puts your business in front of the right people at the right time.",
    description: [
      "Seeking a performance marketing agency that can drive growth? At Ad Hawk Technologies, we are able to help businesses connect with the right audience at the right time with very targeted campaigns.",
      "We use performance marketing that ensures your budget is not wasted, that you get the best return on investment, and that you have high converting leads from data-driven PPC campaigns. From start-ups to established brands, we guarantee instant visibility, increased engagement, and scalable growth.",
      "We don't just display ads; we create business results."
    ],
    whyChoose: [
      { label: "Hyper-targeted audience reach" },
      { label: "Data-driven campaign optimization" },
      { label: "Reduced cost-per-click (CPC)" },
      { label: "Higher conversion rates" },
      { label: "Transparent reporting & analytics" }
    ],
    performanceServices: [
      {
        title: "Search Ads (PPC Ads)",
        body:
          "Our search engine advertising services enable you to reach users who are actively looking for your products or services. We develop keyword strategies with high intent that will position your business at the top of search results.",
        bullets: [
          "Capture ready-to-buy customers.",
          "Boost leads by as much as 3x.",
          "Maximize ROI with optimized bidding."
        ]
      },
      {
        title: "Display Advertising",
        body:
          "Reach more people with engaging display ad campaigns on websites, apps and digital platforms.",
        bullets: [
          "Connect with over 90% of Internet users.",
          "The following formats are available for Banner, Text & Video Ads:",
          "Good brand recognition & recall"
        ]
      },
      {
        title: "YouTube Advertising",
        body: "Harness the power of video with captivating and converting YouTube ads.",
        bullets: [
          "Improve engagement by as much as 300%.",
          "Creative storytelling & branding",
          "Interest & behavior-based target audiences"
        ]
      },
      {
        title: "Retargeting Ads",
        body:
          "Reconnect with visitors who didn’t convert the first time using advanced retargeting strategies.",
        bullets: [
          "Pixel-based & list-based retargeting",
          "Lower CPC & higher conversions",
          "Personalized ad experiences"
        ]
      },
      {
        title: "Landing Page Optimization",
        body:
          "A good ad requires a high-converting landing page. We create landing pages for conversions that convert visitors into customers.",
        bullets: [
          "Optimized UI/UX design",
          "Persuasive copywriting",
          "Using A/B testing to improve results. A/B testing for improved results."
        ]
      },
      {
        title: "Google Shopping Ads",
        body:
          "Our Google Shopping campaigns are ideal for eCommerce companies to feature your products right in search results.",
        bullets: [
          "Show product pictures and prices. Display product photos and prices.",
          "Capture high-purchase-intent users.",
          "Increase online sales."
        ]
      },
      {
        title: "Social Ads",
        body:
          "Connect with your audience on their preferred social media platforms with targeted ads.",
        bullets: [
          "Create Facebook, Instagram & LinkedIn ads. Develop Facebook, Instagram & LinkedIn ads.",
          "Interest & behavior-based targeting",
          "Increase engagement & promotion."
        ]
      },
      {
        title: "Local Services Ads",
        body:
          "Expand local reach by running geo-targeted ads that attract local customers.",
        bullets: [
          "Target specific locations.",
          "Encourage more pedestrian traffic & local leads.",
          "The primary goal is to optimize for calls, visits, & conversions."
        ]
      }
    ],
    offers: [
      "Google Ads (Search, Display, Shopping)",
      "Social media ads (Facebook, Instagram, LinkedIn)",
      "This is the keyword targeting & bid management. This is keyword targeting & bid management.",
      "Ad copywriting & creative design",
      "Landing page optimization",
      "You can use conversion tracking & performance analysis to monitor how your ads are performing."
    ],
    benefits: [
      "You can get instant traffic and leads.",
      "Reach that is highly targeted.",
      "Complete budget management power.",
      "Measurable ROI"
    ],
  },
  {
    key: "smo",
    icon: "SMO",
    title: "Social Media Marketing (SMM)",
    image: images.services.smo,
    headline: "Social Media Marketing Agency – Generate Real Growth on All Platforms.",
    intro: "Your customers are scrolling, liking, sharing, and purchasing on social media every single day in today's digital world. The question is—Is your brand being visible where it really counts?",
    description: [
      "We're a results-focused social media marketing company at Ad Hawk Technologies that helps businesses reach wider audiences, generate high-quality leads, and turn engagement into real revenue. Every campaign we build is conversion-focused, data-backed, and tailored specifically to your brand and goals."
    ],
    content: [
      { type: "h3", text: "Our Social Media Marketing Services" },
      { type: "p", text: "No two businesses are the same — and neither are our strategies. We combine platform expertise, audience insights, and creative execution to deliver social media campaigns that actually perform." },
      
      { type: "h4", text: "01. Facebook Marketing" },
      { type: "p", text: "With over 2.85 billion monthly active users, Facebook remains one of the most powerful advertising platforms in the world — if you know how to use it right." },
      { type: "p", text: "We create Facebook ad campaigns built on solid data, deep audience research, and proven creative strategies. Whether it's organic content that builds community or highly targeted paid ads that drive conversions, our team ensures every dollar of your budget works as hard as possible." },
      { type: "p", text: "What we offer:" },
      { type: "ul", items: [
        "Custom audience targeting and retargeting campaigns",
        "Engaging organic post strategies to grow your page",
        "A/B tested ad creatives for maximum ROI",
        "Full funnel campaigns from awareness to conversion"
      ] },
      { type: "p", text: "The result: Greater brand exposure, a loyal following, and a steady flow of qualified leads." },
 
      { type: "h4", text: "02. Instagram Marketing" },
      { type: "p", text: "Instagram isn't just a photo-sharing app anymore — it's a lead generation powerhouse. Over 200 million people visit at least one business profile on Instagram every single day, and your brand needs to be part of that conversation." },
      { type: "p", text: "Our Instagram marketing strategy is built around trend-driven visual content that stops the scroll, captures attention, and drives action. From Reels to Stories to shoppable posts, we help your brand create a lasting impression on the people who matter most." },
      { type: "p", text: "What we offer:" },
      { type: "ul", items: [
        "High-impact Reels and Stories content",
        "Influencer collaboration and UGC campaigns",
        "Instagram Shopping setup and optimization",
        "Engagement-focused community management"
      ] },
      { type: "p", text: "The result: A visually compelling brand presence that attracts followers and converts them into customers." },
 
      { type: "h4", text: "03. LinkedIn Marketing" },
      { type: "p", text: "When it comes to B2B social media marketing, no platform comes close to LinkedIn. It's where decision-makers, industry leaders, and high-value prospects spend their time — and we help you reach them with precision." },
      { type: "p", text: "Our LinkedIn marketing services are designed to position your brand as a credible thought leader in your industry. We create rich, insight-driven content that keeps you top of mind with your ideal clients and helps you consistently fill your B2B pipeline." },
      { type: "p", text: "What we offer:" },
      { type: "ul", items: [
        "Targeted LinkedIn ad campaigns (Sponsored Content, InMail, Lead Gen Forms)",
        "Thought leadership content and company page management",
        "LinkedIn profile and company page optimization",
        "Niche audience targeting by industry, role, and seniority"
      ] },
      { type: "p", text: "The result: Stronger professional relationships, greater brand authority, and a consistent flow of high-value B2B leads." },
 
      { type: "h4", text: "04. YouTube Marketing" },
      { type: "p", text: "YouTube is the second largest search engine in the world — and most businesses are completely underutilizing it. We help you change that." },
      { type: "p", text: "Our YouTube marketing campaigns are hyper-targeted, high-impact, and designed to attract viewers who are already looking for what you offer. From pre-roll ads to in-feed video campaigns, we connect your brand with high-intent audiences and drive them straight to conversion." },
      { type: "p", text: "What we offer:" },
      { type: "ul", items: [
        "YouTube ad campaign setup and management (TrueView, bumper ads, discovery ads)",
        "SEO-optimized video titles, descriptions, and tags",
        "Channel growth strategies and audience building",
        "Remarketing campaigns to re-engage past visitors"
      ] },
      { type: "p", text: "The result: More qualified website traffic, stronger brand recall, and campaigns that generate up to 3x more revenue than traditional display advertising." },
 
      { type: "h4", text: "05. TikTok Marketing" },
      { type: "p", text: "TikTok has completely transformed how brands connect with audiences. With over 1 billion active users and an algorithm that gives even new accounts the chance to go viral, TikTok represents one of the biggest organic growth opportunities available right now — especially for brands targeting younger, highly engaged audiences." },
      { type: "p", text: "We help businesses cut through the noise with authentic, platform-native TikTok content that entertains, educates, and converts. Whether you're looking to build brand awareness or drive direct sales, our TikTok strategies are built for the way this platform actually works." },
      { type: "p", text: "What we offer:" },
      { type: "ul", items: [
        "Short-form video content strategy and creation",
        "TikTok paid ad campaigns (In-Feed Ads, TopView, Branded Hashtag Challenges)",
        "TikTok Shop setup and product promotion",
        "Influencer and creator partnerships for organic reach",
        "Trend monitoring and rapid content ideation"
      ] },
      { type: "p", text: "The result: Explosive organic reach, viral brand moments, and a direct connection with one of the most engaged audiences on the internet." },
 
      { type: "h4", text: "06. Influencer Marketing" },
      { type: "p", text: "People trust people — not ads. That's exactly why influencer marketing has become one of the most effective tools in a brand's arsenal. When your product is recommended by someone your target audience already loves and trusts, the impact is immediate and powerful." },
      { type: "p", text: "Our influencer marketing service goes beyond simply finding someone with a large following. We identify influencers whose audience genuinely aligns with your brand, manage the entire collaboration process, and ensure every partnership drives authentic engagement and measurable sales." },
      { type: "p", text: "What we offer:" },
      { type: "ul", items: [
        "Influencer identification, vetting, and outreach",
        "Campaign strategy and creative briefing",
        "Micro, macro, and mega influencer campaigns",
        "Performance tracking and ROI reporting"
      ] },
      { type: "p", text: "The result: Authentic brand advocacy, increased consumer trust, and a significant boost in conversions." },
 
      { type: "h4", text: "07. Pinterest Marketing" },
      { type: "p", text: "Pinterest users aren't just browsing — they're actively planning purchases. This makes Pinterest one of the most underrated platforms for reaching prospects early in their buyer journey, when they're most open to discovering new brands." },
      { type: "p", text: "Our Pinterest marketing strategies leverage the platform's powerful targeting capabilities and diverse ad formats to connect your brand with high-intent audiences at exactly the right moment." },
      { type: "p", text: "What we offer:" },
      { type: "ul", items: [
        "Promoted Pin campaigns and Shopping Ads",
        "Board strategy and keyword-optimized pin creation",
        "Audience targeting based on interests, keywords, and demographics",
        "Pinterest Analytics tracking and campaign optimization"
      ] },
      { type: "p", text: "The result: Strong brand awareness, highly engaged traffic, and leads that are already primed to convert." },
 
      { type: "h4", text: "08. Twitter / X Marketing" },
      { type: "p", text: "Twitter (now X) remains one of the fastest-moving platforms for real-time conversations, trending topics, and direct brand-to-consumer engagement. With the right strategy, it's a powerful channel for growing a loyal, high-value audience." },
      { type: "p", text: "Ad engagement on Twitter grew by 35% in a single quarter, and brands that invest in strategic Twitter marketing consistently see stronger reach and interaction. We help you promote your content to the right people, grow your follower base, and drive meaningful conversations around your brand." },
      { type: "p", text: "What we offer:" },
      { type: "ul", items: [
        "Promoted tweet and Twitter ad campaign management",
        "Content strategy for organic follower growth",
        "Real-time trend monitoring and reactive content",
        "Audience targeting to maximize relevance and engagement"
      ] },
      { type: "p", text: "The result: Up to 150% more clicks, replies, and retweets — and a growing community of high-value followers who genuinely care about your brand." },
 
      { type: "h4", text: "09. Social Media Management" },
      { type: "p", text: "Maintaining a consistent, professional presence across multiple platforms is a full-time job. That's where we come in." },
      { type: "p", text: "As a full-service social media management company, we handle everything — from choosing the right platforms for your business to creating scroll-stopping content, monitoring conversations, responding to your audience, and tracking performance across every channel." },
      { type: "p", text: "What we offer:" },
      { type: "ul", items: [
        "Platform selection and social media strategy development",
        "Content creation, scheduling, and publishing",
        "Community management and audience engagement",
        "Brand reputation monitoring and response strategy",
        "In-depth performance reporting using industry-leading tools"
      ] },
      { type: "p", text: "The result: A cohesive, active brand presence that builds trust, drives engagement, and frees you up to focus on running your business." },
 
      { type: "h3", text: "Why Partner With Us for Social Media Marketing?" },
      { type: "p", text: "There's no shortage of social media agencies making big promises. Here's why businesses across industries choose Ad Hawk Technologies:" },
      { type: "ul", items: [
        "Platform specialists, not generalists — we know each platform inside and out",
        "Data-driven decisions — every strategy is backed by research and real-time insights",
        "Creative content that actually performs — we combine storytelling with conversion strategy",
        "Complete transparency — detailed reporting so you always know your ROI",
        "End-to-end service — from strategy and content creation to execution and optimization"
      ] },
 
      { type: "h3", text: "Ready to Elevate Your Social Media Presence?" },
      { type: "p", text: "Whether you're starting from scratch or looking to take your existing social media to the next level, we're here to help you build a strategy that delivers real, lasting results." },
 
      { type: "h3", text: "Our social media marketing process" },
      { type: "p", text: "Unveil the journey to social media success with the most trusted social media marketing agency" },
      { type: "ol", items: [
        "Audit your current social media presence",
        "Identify relevant and profitable social media channels",
        "Set realistic and measurable goals",
        "Identify key success metrics",
        "Create a social media calendar",
        "Ideation and content creation",
        "Ad optimization and content publishing",
        "Campaign monitoring and reporting"
      ] },
 
      { type: "h3", text: "Let's build something remarkable together." }
    ],
    offers: [
      "Profile setup & optimization",
      "Content creation (posts, reels, stories)",
      "Monthly content calendar",
      "Audience engagement & community management",
      "Hashtag & trend research",
      "Analytics and performance tracking"
    ],
    benefits: ["Increased followers & engagement", "Strong brand awareness", "Better audience connection", "Consistent online presence"],
  },
  {
    key: "sem",
    icon: "SEM",
    title: "Search Engine Marketing (SEM)",
    image: images.services.sem,
    headline: "Get to the Top of Google with SEM Agency. Instantly.",
    intro: "Powerful growth comes from organic growth, but it takes time. What if your business is in need of qualified leads and paying customers now? This is where Search Engine Marketing (SEM) comes in.",
    description: [
      "We're a performance-based SEM agency at Ad Hawk Technologies, helping businesses get to the top of search results the first time customers are searching for what they have to offer. Each campaign we create is laser-focused on one thing: the best return on every rupee that you invest.",
      "In paid search, it isn't about budget—it's about strategy, execution, and expertise."
    ],
    content: [
      { type: "h3", text: "So what is SEM, and why is it important for your business?" },
      { type: "p", text: "Search Engine Marketing is the use of paid ads on search engine result pages (mainly Google and Bing) to promote your business. Your ad will show up at the top of the page when someone enters a keyword that relates to your product or service, which is above all of the organic search results, putting your brand directly in front of high-intent buyers at the time they're ready to act." },
      { type: "p", text: "As opposed to the traditional advertising that targets people who might not be interested, SEM targets those who are actively looking for the products and services you provide. That is why it is one of the most effective and affordable digital marketing tools on the market today." },
      { type: "p", text: "Smart businesses invest in SEM for these reasons:" },
      { type: "ul", items: [
        "Immediate visibility—be seen on Google from day one.",
        "High purchase intent—reach those who are actively looking for your product/service.",
        "Completely measurable—every click, conversion, and rupee spent is tracked in real time.",
        "Full budget control—spend more or less than you like, and change the budget at any time.",
        "Highly targeted—get the right people by keyword, location, device, time, and more.",
        "Complements SEO—SEM gives immediate results while SEO takes time to build.",
        "Scalable growth—increment budget based on successful campaigns and predictability of growth."
      ] },

      { type: "h3", text: "Our SEM Services" },

      { type: "h4", text: "01. Google Ads Management" },
      { type: "p", text: "Google receives more than 8.5 billion searches every day—and Google Ads puts your business at the top of the list. However, making money with Google Ads isn't just about setting a budget and picking a few keywords. If you're not going to optimize it and do it right, it's quite easy to end up spending a lot of money and getting very little return." },
      { type: "p", text: "Our Google Ads experts create, manage, and continually refine campaigns that are optimally designed to get the most out of your advertising budget and ensure that your campaigns are generating measurable and predictable outcomes. Whether it's search ads, display ads, shopping ads, or more—we have your back." },
      { type: "p", text: "What we offer:" },
      { type: "ul", items: [
        "Google Ads account setup and campaign structure are provided.",
        "In-depth keyword research and match type strategy",
        "A compelling ad copy that is made and tested.",
        "Bid strategy and budget management",
        "Optimizing the Quality Score for cheaper CPCs.",
        "Wasted spend through negative keyword management",
        "The ability to set up conversion tracking and goals.",
        "Continuous monitoring and optimization of campaigns"
      ] },
      { type: "p", text: "The result: A very profitable Google Ads account that brings in qualified traffic, leads, and sales—and at the lowest cost per acquisition." },

      { type: "h4", text: "02. Search Ad Campaigns" },
      { type: "p", text: "Search ads are the mainstay of SEM—text ads that show up at the top and bottom of Google search results when someone types your target keywords into the search bar. When done correctly, they are one of the most effective types of online advertising, as they are capturing demand that has already been created." },
      { type: "p", text: "We develop search campaigns based on deep keyword intelligence and searcher intent, ensuring your ads show up for the searches that are most likely to convert, and with messaging that's just what your ideal customer is looking for at just the right moment." },
      { type: "p", text: "What we offer:" },
      { type: "ul", items: [
        "The research of keywords with buyer intent. Researching keywords with buyer intent.",
        "Ad group structuring for maximum relevance",
        "Creating and testing responsive search ads.",
        "Content for your ad that resonates with customer pain points",
        "A higher Quality Score is achieved by landing page alignment. Landing page alignment is the key to a higher Quality Score.",
        "Search term analysis and continuous optimization.",
        "The strategy for monitoring and positioning competitors."
      ] },
      { type: "p", text: "The result: Search campaigns that attract high-intent clicks, minimize wasted budget, and drive a consistent flow of qualified leads straight to your business." },

      { type: "h4", text: "03. Display Advertising" },
      { type: "p", text: "Some potential customers aren't looking now—but that doesn't mean you can't target them. Google's Display Network connects with more than 90% of Internet users worldwide through millions of sites, apps, and platforms." },
      { type: "p", text: "Display advertising helps you remain visible and memorable to your target audience when they are surfing the web, creating awareness, repeating your message, and re-engaging visitors who didn't convert the first time. We design eye-catching display campaigns that get noticed and get people to take action throughout the Google Display Network." },
      { type: "p", text: "What we offer:" },
      { type: "ul", items: [
        "Audience targeting (interest, demographic, and in-market segments)",
        "The ability to create custom intent and affinity audiences. The ability to create custom intent and affinity audiences.",
        "A great banner and responsive display ad design.",
        "Targeting on relevant websites and apps",
        "To prevent ad fatigue, set a maximum frequency limit for the ad.",
        "Performance monitoring and creative optimization."
      ] },
      { type: "p", text: "The result: wide brand recognition and web presence—ensuring that your business is always top of mind for the right people at the right time." },

      { type: "h4", text: "04. Remarketing & Retargeting Campaigns" },
      { type: "p", text: "Did you know that 97% of the first-time visitors to a website do not take any action? The way you get them back is through remarketing." },
      { type: "p", text: "Remarketing is a tactic that targets individuals who have already visited your website, interacted with your content, or interacted with your brand in some other manner and then serves them highly relevant ads as they continue to browse the web. These audiences are more likely to convert than cold audiences, as they've already expressed an interest in your business." },
      { type: "p", text: "We create smart remarketing campaigns that bring back your hottest prospects and push them back through the sales funnel and towards conversion." },
      { type: "p", text: "What we offer:" },
      { type: "ul", items: [
        "How to create a Google Ads Remarketing List and segment it.",
        "Dynamic remarketing for eCommerce product retargeting",
        "Funnel progression sequential remarketing ads.",
        "Cross-platform retargeting strategy",
        "On-site behavior custom audience messaging",
        "Optimizing for frequency and recency."
      ] },
      { type: "p", text: "The result: Improved conversion rates, reduced cost-per-acquisition, and much better ROI for your advertising spend." },

      { type: "h4", text: "05. Google Shopping Ads" },
      { type: "p", text: "Google Shopping Ads are among the most potent weapons in your eCommerce arsenal if you're running an eCommerce business. These ads are visual product ads that are directly displayed in Google search results, with your product image, price, and store name to shoppers who are actively looking to purchase your product." },
      { type: "p", text: "We create and run shopping campaigns to get your products in front of high-intent customers at the right time and place, bringing qualified traffic directly to your product pages and increasing your eCommerce revenue." },
      { type: "p", text: "What we offer:" },
      { type: "ul", items: [
        "A Google Merchant Center setup and optimization of product feeds. Google Merchant Center setup and optimization of product feeds.",
        "Organizing a shopping campaign and bidding strategy.",
        "Optimization of product title and description for improved visibility.",
        "This enables users to manage their Smart Shopping and Performance Max campaigns. This allows users to manage their Smart Shopping and Performance Max campaigns.",
        "Positioning analysis and competitive pricing analysis.",
        "Bid optimization and performance tracking with ROAS as the focus."
      ] },
      { type: "p", text: "The result: increased product visibility in Google search, increased qualified traffic to your store, and much more eCommerce revenue, while maintaining a high ROI." },

      { type: "h4", text: "06. YouTube Ads" },
      { type: "p", text: "YouTube is the second biggest search engine in the world—and YouTube advertising provides you with access to more than 2 billion logged-in users each month. It's one of the world's most effective platforms to fuse the power of video storytelling with the targeting power of search ads." },
      { type: "p", text: "Whether you're looking to grow brand awareness at the top of the funnel or conversions further down, we create and manage YouTube ad campaigns that put your brand's message in front of the right people." },
      { type: "p", text: "What we offer:" },
      { type: "ul", items: [
        "The strategy for creating YouTube campaigns and how to target audiences.",
        "In-stream ad management, including skippable and non-skippable options. In-stream ad management – skippable and non-skippable.",
        "Bumper ad and discovery ad campaigns",
        "Developing video ad brief and creation.",
        "Remarketing to website visitors via YouTube",
        "Look at the rate, click-through rate, and conversion optimization."
      ] },
      { type: "p", text: "The result: Highly effective video ads that scale brand awareness, attract high-intent traffic, and provide measurable ROI on one of the world's most engaged platforms." },

      { type: "h4", text: "07. Landing Page Optimization" },
      { type: "p", text: "You can't simply generate traffic to your website and let it get there. Generating traffic to your website is not enough. If you don't have a landing page that turns that traffic into leads or sales, you are wasting your money on clicks and leads that don't convert. The top paid advertising error (and the most expensive) is a poorly optimized landing page." },
      { type: "p", text: "We create and fine-tune high-converting landing pages that are tailored for your SEM campaigns—so that everyone who clicks on your ad has the greatest opportunity to convert." },
      { type: "p", text: "What we offer:" },
      { type: "ul", items: [
        "Design and copywriting for conversions.",
        "Clear and compelling calls to action and lead capture forms.",
        "Page speed optimization for better quality scores and user experience",
        "Responsive to all devices on the mobile front end",
        "Testing headlines, copy, layout, and CTAs with A/B testing. A/B testing headlines, copy, layout and CTAs.",
        "User behavior analysis and heatmap analysis."
      ] },
      { type: "p", text: "The result: Landing pages that convert paid visitors into actual leads and customers significantly enhance your conversion rate and lower your cost per acquisition." },

      { type: "h4", text: "08. SEM Audit & Account Takeover" },
      { type: "p", text: "Currently running Google Ads but not getting the results you are looking for? You're not alone. Many businesses are spending a lot of money on advertising without realizing it because they have poor account organization, too general of targeting, poor ad copy, and/or no conversion tracking." },
      { type: "p", text: "Our SEM audit service provides you with a comprehensive and honest report of where your money is being spent—and what you can do to make better use of it right away." },
      { type: "p", text: "What we offer:" },
      { type: "ul", items: [
        "Comprehensive Google Ads account review and reporting.",
        "Wasted spend identification and immediate quick wins",
        "Review keywords, ad copy, and landing pages.",
        "To verify and set up conversion tracking. To check and install conversion tracking.",
        "Comparing competitor strengths and weaknesses. Benchmarking and gap analysis of competitors.",
        "Restructuring and optimization roadmap",
        "Easy account takeover and campaign management."
      ] },
      { type: "p", text: "The result: You'll know exactly why your existing campaigns aren't working and have a clear path to quickly get them on track and start seeing the ROI you deserve." },

      { type: "h3", text: "What if Your SEM Strategy is Wrong?" },
      { type: "p", text: "Google Ads without the proper strategy is not only not effective; it actually costs money. The typical consequences of bad SEM management are:" },
      { type: "ol", items: [
        "Wasted Budget on the Wrong Keywords — Too broad, too un-researched, and people who click on these keywords were never going to purchase. If you don't target your keywords and manage negative keywords, a lot of your money is going down the drain on traffic that isn't relevant to your site.",
        "High Clicks, Zero Conversions—Traffic without conversions means that your landing page, ad messaging, or audience targeting is out of alignment. Each click is a dollar—and when they don't convert, that dollar is lost.",
        "Rising Cost Per Acquisition — If you don't optimize, your cost per lead or sale will gradually get higher. A successful campaign slowly turns into a costly routine that yields less and less.",
        "You're losing ground to your competitors—your competitors are advertising on Google now. If they're not using a well-managed SEM strategy, they're taking the clicks—and the customers—that are meant for you.",
        "No Visibility into What's Working — If you don't have the right conversion tracking and reporting tools, you don't know which campaigns, keywords, and ads are actually working. One of the quickest ways to run out of budget."
      ] },

      { type: "h3", text: "Our SEM Process" },
      { type: "p", text: "All of our SEM engagements are done in a methodical and results-driven process:" },
      { type: "ol", items: [
        "Business & Goal Discovery — Identifying your goals, target audience, and competition.",
        "Reviewing any existing campaigns to see if there are opportunities and issues in the account.",
        "Keyword Research & Strategy — Creating a full list of keywords based on intent and opportunity",
        "Campaign Build & Setup—Organizing campaigns, ad groups, and ads for optimal relevance and quality score.",
        "Landing Page Review & Optimization — Making sure your destination pages are optimized to convert.",
        "Launch & Active Monitoring — Starting live and keeping an eye on performance from the get-go",
        "Continuous Optimization—Making continual changes to bids, keywords, ads, and audiences driven by actual data.",
        "Transparent Reporting — Regular performance reviews with clear insights and forward recommendations"
      ] },

      { type: "h3", text: "Ad Hawk Technologies: Why You Should OPT for Them for SEM?" },
      { type: "p", text: "Running profitable paid search campaigns is an art and science. Why businesses across Mumbai trust Ad Hawk Technologies with their SEM investment: Industry experts who have worked with Google Ads and have been certified." },
      { type: "ul", items: [
        "Performance-oriented—we optimize constantly; your budget deserves to be hard-working.",
        "We don't just drive traffic; we optimize the entire path to conversion—that's full funnel thinking.",
        "Complete transparency—you know where every rupee goes, and you own your accounts.",
        "No contracts; we only do what works—we get your business, not through a contract, but because it is working.",
        "Integrated approach—your SEM strategy is in sync with your SEO, content, and social media strategies."
      ] },

      { type: "h3", text: "Looking to get your business on top of Google?" },
      { type: "p", text: "If you're not running an efficient SEM campaign, you're losing customers who are actively looking for the products and services you provide each day." },
      { type: "p", text: "From launching your first Google Ads campaign to significantly enhancing the performance of your existing campaign, Ad Hawk Technologies has the expertise, tools, and commitment to make your paid search investment truly profitable." },
      { type: "p", text: "Get your business to the top—and stay there." }
    ],
    offers: [
      "The setup and management of the search ads campaign.",
      "Keyword bidding strategy",
      "Ad extensions optimization",
      "A/B testing for ads",
      "Conversion rate optimization",
      "Detailed analytics & reporting"
    ],
    benefits: [
      "Immediate search visibility",
      "High-intent audience targeting",
      "Increased lead generation",
      "Scalable campaigns"
    ],
  },
  {
    key: "email",
    icon: "Email",
    title: "Email Marketing",
    image: images.services.email,
    headline: "Turn Every Email Into a Revenue Opportunity",
    intro:
      "Most businesses send emails. Very few send emails that actually get opened, read, and acted upon. We build email campaigns that land with the right audience at the right time—driving measurable results across your funnel.",
    description: [
      "At Ad Hawk Technologies, we design and execute strategic email marketing that nurtures leads, retains customers, and drives direct sales. Email is still one of the highest-ROI channels—but only when it’s done with clear strategy, strong creative, and smart automation.",
      "We focus on relevance, segmentation, deliverability, and continuous optimization—so your emails don’t feel like “marketing,” they feel like a helpful conversation that moves customers closer to action.",
    ],
    content: [
      {
        type: "p",
        text: "Most businesses send emails. Very few send emails that actually get opened, read, and acted upon.",
      },
      {
        type: "p",
        text: "At Ad Hawk Technologies, we're an email marketing agency that bridges that gap. We design and execute strategic email marketing campaigns that land in the right inboxes at the right time — with the right message. Whether your goal is to nurture leads, retain existing customers, or drive direct sales, we build email strategies that consistently deliver measurable results.",
      },
      {
        type: "p",
        text: "Email marketing still delivers one of the highest ROIs of any digital marketing channel — $42 for every $1 spent, on average. The question isn't whether you should be doing it. It's whether you're doing it right.",
      },

      { type: "h3", text: "Our Email Marketing Services" },

      { type: "h4", text: "01. Email Strategy & Campaign Planning" },
      {
        type: "p",
        text: "Every successful email campaign starts with a solid strategy. Without one, you're just sending noise. We build a comprehensive roadmap aligned with your broader marketing goals and your customers' buying journey.",
      },
      { type: "p", text: "What we offer:" },
      {
        type: "ul",
        items: [
          "Audience segmentation and persona development",
          "Campaign calendar planning and scheduling",
          "Goal setting with clear, trackable KPIs",
          "Funnel mapping — from first touch to loyal customer",
        ],
      },
      {
        type: "p",
        text: "The result: A purposeful email strategy that builds relationships and drives consistent revenue.",
      },

      { type: "h4", text: "02. Email Template Design & Copywriting" },
      {
        type: "p",
        text: "Your email has about 3 seconds to make an impression. We design clean, mobile-responsive templates and write persuasive, human copy that guides readers naturally toward action.",
      },
      { type: "p", text: "What we offer:" },
      {
        type: "ul",
        items: [
          "Custom, branded email template design",
          "Mobile-optimized layouts for all devices",
          "Compelling subject lines and preview text",
          "Conversion-focused email copywriting",
          "Clear, clickable calls to action (CTAs)",
        ],
      },
      {
        type: "p",
        text: "The result: Emails that get opened, read, and clicked — not sent straight to the trash.",
      },

      { type: "h4", text: "03. Email Automation & Drip Campaigns" },
      {
        type: "p",
        text: "Email automation is your 24/7 relationship builder. We set up intelligent workflows that deliver the right message at the right moment — from welcome sequences to abandoned cart recovery.",
      },
      { type: "p", text: "What we offer:" },
      {
        type: "ul",
        items: [
          "Welcome and onboarding email sequences",
          "Lead nurturing drip campaigns",
          "Abandoned cart and browse abandonment emails",
          "Post-purchase and upsell email flows",
          "Re-engagement campaigns for inactive subscribers",
        ],
      },
      { type: "p", text: "The result: More conversions on autopilot — with less manual effort and zero missed opportunities." },

      { type: "h4", text: "04. List Building & Audience Segmentation" },
      {
        type: "p",
        text: "Sending the same email to your entire list is one of the fastest ways to lose subscribers. We help you grow a healthy, permission-based list — then segment it intelligently for hyper-relevant campaigns.",
      },
      { type: "p", text: "What we offer:" },
      {
        type: "ul",
        items: [
          "Lead magnet strategy and opt-in form optimization",
          "Landing page creation for list growth",
          "Behavioral and demographic segmentation",
          "Dynamic content personalization",
          "List cleaning and deliverability management",
        ],
      },
      { type: "p", text: "The result: A high-quality, engaged email list that responds to your campaigns and drives real sales." },

      { type: "h4", text: "05. Promotional & Newsletter Campaigns" },
      {
        type: "p",
        text: "Promotional emails and newsletters keep your brand top-of-mind and drive repeat purchases when they’re written with clarity, value, and strong CTAs.",
      },
      { type: "p", text: "What we offer:" },
      {
        type: "ul",
        items: [
          "Product launch and promotional email campaigns",
          "Monthly or weekly newsletter creation",
          "Holiday and seasonal campaign planning",
          "Exclusive subscriber offers and loyalty campaigns",
          "Event invitations and announcement emails",
        ],
      },
      { type: "p", text: "The result: Higher open rates, stronger brand loyalty, and repeat customers who look forward to hearing from you." },

      { type: "h4", text: "06. Transactional Email Optimization" },
      {
        type: "p",
        text: "Transactional emails have some of the highest open rates — yet most brands treat them as an afterthought. We turn them into branded touchpoints that build trust and drive repeat purchases.",
      },
      { type: "p", text: "What we offer:" },
      {
        type: "ul",
        items: [
          "Branded transactional email design",
          "Upsell and cross-sell opportunities within transactional emails",
          "Triggered confirmation and notification emails",
          "Post-purchase review and referral request emails",
        ],
      },
      { type: "p", text: "The result: A better post-purchase experience that builds loyalty and generates additional revenue from every transaction." },

      { type: "h4", text: "07. A/B Testing & Performance Optimization" },
      {
        type: "p",
        text: "Great email marketing is never set-and-forget. We run systematic A/B tests across subject lines, send times, CTAs, and layouts — then use the insights to improve performance over time.",
      },
      { type: "p", text: "What we offer:" },
      {
        type: "ul",
        items: [
          "Subject line and preview text A/B testing",
          "CTA placement, design, and copy testing",
          "Send time and frequency optimization",
          "Email layout and visual hierarchy testing",
          "Continuous performance benchmarking",
        ],
      },
      { type: "p", text: "The result: Campaigns that get better over time — with steadily improving open rates, click-through rates, and conversions." },

      { type: "h4", text: "08. Email Analytics & Reporting" },
      {
        type: "p",
        text: "You can't improve what you don't measure. We provide clear, honest reporting—so you always know what’s working, what isn’t, and what to do next.",
      },
      { type: "p", text: "What we offer:" },
      {
        type: "ul",
        items: [
          "Open rate, click-through rate, and conversion tracking",
          "Revenue attribution per campaign",
          "Subscriber growth and churn analysis",
          "Deliverability and spam score monitoring",
          "Monthly performance reviews and strategy recommendations",
        ],
      },
      { type: "p", text: "The result: Complete visibility into your email marketing ROI — and a clear roadmap for continuous improvement." },

      { type: "h3", text: "Why Email Marketing Still Outperforms Almost Every Other Channel" },
      {
        type: "p",
        text: "Email marketing stands out for one simple reason: you own your audience. No platform changes can cut off your access, and no algorithm update can bury your message.",
      },
      {
        type: "ul",
        items: [
          "Highest ROI of any digital channel — averaging $42 return per $1 spent",
          "Direct access to your audience — no algorithm standing between you and your customers",
          "Fully measurable — every open, click, and conversion is tracked",
          "Highly scalable — send to 100 or 100,000 subscribers with the same effort",
          "Works at every stage of the funnel — from first-time visitor to loyal repeat customer",
          "Complements every other marketing channel — amplifying the results of your SEO, social media, and paid campaigns",
        ],
      },

      { type: "h3", text: "What Happens When You Ignore Email Marketing?" },
      {
        type: "ul",
        items: [
          "Lost leads that visit your website and never return",
          "No repeat business from customers who've already bought from you",
          "Wasted ad spend on acquiring new customers instead of retaining existing ones",
          "Zero direct communication with your audience outside of social media",
          "Slower sales cycles because leads aren't being nurtured toward a decision",
        ],
      },

      { type: "h3", text: "Our Email Marketing Process" },
      {
        type: "ol",
        items: [
          "Discovery & Goal Setting — understanding your business, audience, and objectives",
          "List Audit & Segmentation — cleaning and organizing your existing subscriber base",
          "Strategy & Campaign Planning — building a roadmap aligned with your sales funnel",
          "Template Design & Copywriting — creating branded, conversion-focused email assets",
          "Automation Setup — building workflows that run seamlessly in the background",
          "Campaign Launch & Monitoring — sending campaigns and tracking real-time performance",
          "A/B Testing & Optimization — continuously refining based on data and insights",
          "Reporting & Strategy Review — monthly reviews to keep improving results over time",
        ],
      },

      { type: "h3", text: "Why Choose Ad Hawk Technologies for Email Marketing?" },
      {
        type: "ul",
        items: [
          "Custom strategies built around your specific business goals — never a generic template",
          "Creative + technical expertise under one roof — beautiful design meets smart automation",
          "Platform agnostic — we work with Mailchimp, Klaviyo, HubSpot, ActiveCampaign, and more",
          "Deliverability focus — we make sure your emails actually land in the inbox, not spam",
          "Transparent reporting — honest numbers, clear insights, and no fluff",
        ],
      },

      { type: "h3", text: "Ready to Make Email Your Most Profitable Marketing Channel?" },
      {
        type: "p",
        text: "Whether you're starting your email marketing from scratch or looking to improve an existing program, Ad Hawk Technologies has the expertise, creativity, and strategy to take your campaigns to the next level. Let's turn your email list into your biggest revenue asset.",
      },
    ],
    offers: [
      "Email strategy & campaign planning (KPIs + funnel mapping)",
      "Branded email template design + conversion-focused copywriting",
      "Automation & drip sequences (welcome, nurture, re-engagement)",
      "Audience segmentation + personalization",
      "Promotional campaigns + newsletters",
      "A/B testing (subject lines, CTAs, send times)",
      "Analytics, reporting, and ongoing optimization",
    ],
    benefits: [
      "Higher open and click-through rates",
      "More conversions from existing traffic",
      "Stronger customer retention and loyalty",
      "Predictable revenue from automated flows",
      "Clear ROI with measurable reporting",
    ],
  },
  {
    key: "content",
    icon: "Content",
    title: "Content Marketing",
    image: images.services.content,
    headline: "Develop content that attracts, engages, and converts.",
    intro: "The key difference between content that makes a difference for real business results and content that gets lost in the ether is not effort; it's strategy. We create content ecosystems that grow over time.",
    description: [
      "These days, all businesses are creating content. The internet is filled with blog posts, social media updates, videos, infographics—the list goes on and on. The bad news is, however, that most of it goes completely undetected.",
      "It's not about effort; it's about strategy. That's the difference between the content that drives real business results and the content that falls on deaf ears. It's understanding the exact timing, the exact message, and the exact tone to get your audience to move closer to choosing your brand.",
      "We're a results-driven content marketing agency at Ad Hawk Technologies, who produce meaningful and quality content that draws in the right people, establishes trust, and turns readers into loyal customers. Not only do we produce content, we create content ecosystems that are working for your business, day and night.",
      "Great content doesn't cost. It is the most expandable and compounding business asset."
    ],
    content: [
      { type: "h3", text: "What is Content Marketing and why is your business in need of it?" },
      {
        type: "p",
        text: "Content marketing is the strategic creation and sharing of valuable, relevant content that will attract and retain a well-defined audience—and thus lead to profitable customer action.",
      },
      {
        type: "p",
        text: "Content marketing is different from paid advertising in that it continues to work after it's out the door. An optimized blog post can bring in organic traffic for years to come. A good case study can be a deal closer months after it is written. A comprehensive guide can establish your brand as the industry leader forever.",
      },
      { type: "p", text: "Content marketing is a must-have for businesses in today's day and age, and here's why:" },
      {
        type: "ul",
        items: [
          "Generates organic visibility – Quality content is the key to long-term success in SEO.",
          "Builds authority and trust—consistently valuable content makes your brand the go-to place for people to learn about.",
          "Creates qualified leads—content draws in those who are looking for what you offer.",
          "Engages all parts of the funnel from initial awareness to last sale.",
          "Generates compounding ROI—unlike ads, great content is valuable over time.",
          "Lowers cost of customer acquisition—organic content is much more cost-effective than paid traffic when scaled up.",
        ],
      },
      { type: "p", text: "We provide the content marketing services to you." },

      { type: "h4", text: "01. Content Strategy & Planning" },
      {
        type: "p",
        text: "Great content doesn't just come from out of nowhere. It's the outcome of thorough research, logical thinking, and a sound strategy that connects each piece of content to a business objective.",
      },
      {
        type: "p",
        text: "We start by developing a comprehensive content strategy that outlines your audience's customer journey, pinpoints the topics and formats that will have the greatest impact, and provides a clear timeline for how to do it.",
      },
      { type: "p", text: "What we offer:" },
      {
        type: "ul",
        items: [
          "The process of research and creating audience personas. The research and development of audience personas.",
          "Review of current assets and their content.",
          "Content Gap Analysis with competitors.",
          "Topic cluster and pillar page strategy",
          "The development of a content calendar plan and schedule.",
          "Strategies for channels where, when, and why to publish.",
          "Setting KPIs and benchmarking performance.",
        ],
      },
      {
        type: "p",
        text: "The result: A strategic, data-driven content approach that is aligned to your business objectives and provides each piece of content a clear purpose.",
      },

      { type: "h4", text: "02. Blog Writing & Article Creation" },
      {
        type: "p",
        text: "One of the most effective organic growth tools that your business has is a blog that is updated regularly. It brings visitors to your site, enhances your authority, provides valuable information, and makes people want to return to your site.",
      },
      {
        type: "p",
        text: "We create in-depth and expertly researched blogs and articles that truly benefit your audience, meet search intent, and make your brand a trusted voice in your niche.",
      },
      { type: "p", text: "What we offer:" },
      {
        type: "ul",
        items: [
          "Long-form blog posts and articles that are optimized for SEO.",
          "Content that involves thought leadership and expert opinion.",
          "Instructions, how-to, listicles, and education.",
          "News commentary and news trend analysis for the industry.",
          "An inbound linking strategy for better SEO.",
          "Frequent publishing to build an audience.",
        ],
      },
      {
        type: "p",
        text: "The result: A blog that ranks well on Google, brings in targeted organic visitors, and establishes your brand as a trusted industry source.",
      },

      { type: "h4", text: "03. Website Copywriting" },
      {
        type: "p",
        text: "Your website is the first real impression that people will have of your business. If your copy is not clear, compelling, and conversion-oriented, then you're losing potential customers before they even have the opportunity to know you.",
      },
      {
        type: "p",
        text: "We create website copy that performs well in search engines and connects with human readers—converting browsers to leads and leads to customers.",
      },
      { type: "p", text: "What we offer:" },
      {
        type: "ul",
        items: [
          "Web page copywriting for the home page, about, and service page.",
          "SEO-optimized page copy with target keywords",
          "The copy on the landing page is optimized for conversion.",
          "Persistent and strong calls to action throughout.",
          "Consistency of brand voice throughout the site",
          "Meta titles and descriptions for each page",
        ],
      },
      {
        type: "p",
        text: "The result: A site that not only appears on Google but also attracts visitors and converts them into leads and leads into customers.",
      },

      { type: "h4", text: "04. Social Media Content Creation" },
      {
        type: "p",
        text: "It can be very time-consuming to have the same presence across several social media platforms—particularly if you also have to run a business.",
      },
      { type: "p", text: "What we offer:" },
      {
        type: "ul",
        items: [
          "Content creation for platforms (Instagram, LinkedIn, Facebook, Twitter/X, TikTok)",
          "Monthly content calendars, themes, and campaigns.",
          "Interesting captions, hashtag techniques, and post copy",
          "Carousel, reel, and story concept development",
          "Graphic content briefs and creative direction branded",
          "It's a strategy that involves sharing content on several channels. It's a tactic that requires sharing content on several channels.",
        ],
      },
      {
        type: "p",
        text: "The result: A social media presence that is always active, always on brand, and that will expand your social media reach and keep your business in front of your audience.",
      },

      { type: "h4", text: "05. Video Content & Script Writing" },
      {
        type: "p",
        text: "Video is no longer a nice-to-have; it's a must-have. It's the most consumed content format online, and brands that invest in video regularly outperform non-video competitors in engagement, time on site, and conversions.",
      },
      { type: "p", text: "What we offer:" },
      {
        type: "ul",
        items: [
          "Write brand story and explainer video scripts.",
          "YouTube video scripts and content strategy.",
          "Short-form video scripts for Reels, TikTok, and YouTube Shorts.",
          "The structure of product demo and testimonial videos.",
          "Outline and show notes for podcast episodes.",
          "Video SEO optimization (titles, descriptions, tags)",
        ],
      },
      {
        type: "p",
        text: "The result: Video content that captivates your viewers, clearly communicates your value, and gets you measurable results on all platforms.",
      },

      { type: "h4", text: "06. Infographic & Visual Content Creation" },
      {
        type: "p",
        text: "Certain concepts just need to be shared with a picture. We take complex and dense information and make it clean, compelling, and something that your audience wants to read and share—dramatically expanding your content reach and impact.",
      },
      { type: "p", text: "What we offer:" },
      {
        type: "ul",
        items: [
          "Data visualization and statistical infographics",
          "How-to and process visual explainers",
          "Compare and contrast timeline infographics.",
          "Visual content in social media and branded graphics.",
          "Design and make presentations and slideshows.",
          "Content to be shared for link building.",
        ],
      },
      {
        type: "p",
        text: "The result: visual content that's share-worthy, makes complex concepts easy to understand, increases engagement, and attracts valuable backlinks that enhance your site's search engine optimization.",
      },

      { type: "h4", text: "07. Case Studies & White Papers" },
      {
        type: "p",
        text: "Nothing helps a potential customer get closer to making a purchase decision than proof. Real results and real credibility come from case studies and white papers.",
      },
      { type: "p", text: "What we offer:" },
      {
        type: "ul",
        items: [
          "How to write customer success stories and case studies.",
          "In-depth white paper and research report creation",
          "Reports and thought-leadership pieces based on data are valuable.",
          "This is the kind of content that you can create for your email marketing list-building campaign.",
          "Gated content marketing for quality leads",
        ],
      },
      {
        type: "p",
        text: "The result: Engaging content that is supported by solid facts and research, which helps to establish trust in your brand, which helps to speed up buying decisions, and which makes you the clear leader in your niche.",
      },

      { type: "h4", text: "08. Writing for email and newsletters" },
      {
        type: "p",
        text: "Your email list is one of your greatest marketing tools—if it's filled with people who want to read your content. We craft emails that your subscribers will want to read.",
      },
      { type: "p", text: "What we offer:" },
      {
        type: "ul",
        items: [
          "How to write newsletters on a weekly or monthly basis.",
          "The following email sequence copy is for lead nurturing.",
          "The text of promotional and campaign emails. Content of promotional and campaign emails.",
          "How to write a welcome/onboarding sequence. How to write a welcome/onboarding sequence.",
          "Re-engagement campaign copy",
          "Optimizing subject lines for higher open rates. Optimizing subject lines for opens.",
        ],
      },
      {
        type: "p",
        text: "The result: An email program that your audience is interested in—creating loyalty, repeat sales, and brand advocates for life.",
      },

      { type: "h4", text: "09. eBooks & Lead Magnet Creation" },
      {
        type: "p",
        text: "eBooks, guides, checklists, and templates—when executed properly—can be your best lead generation asset. We develop professional lead magnets that will help your list grow with qualified leads.",
      },
      { type: "p", text: "What we offer:" },
      {
        type: "ul",
        items: [
          "The eBook writing and design process is in-depth.",
          "In-depth tutorials and libraries of resources",
          "Checklists, templates and swipe files",
          "Interactive quizzes and assessments",
          "Copy for your landing page to promote your lead magnet",
          "Email follow-ups for new leads.",
        ],
      },
      {
        type: "p",
        text: "The result: A powerful lead magnet that expands your email list of quality leads and nurtures your sales funnel with hot, interested leads.",
      },

      { type: "h4", text: "10. Content Distribution & Promotion" },
      {
        type: "p",
        text: "Generating great content is just half the job. We ensure that your content is seen, shared, and acted on by the right people at the right time through the right channels.",
      },
      { type: "p", text: "What we offer:" },
      {
        type: "ul",
        items: [
          "Search engine optimization for organic search visibility.",
          "The strategy to boost the visibility of social media content. The method of increasing the visibility of social media content.",
          "Distribute and promote your email newsletter.",
          "Influencer and media outreach for content placement",
          "The creation of content on relevant third-party sites. The production of content on relevant third-party sites.",
          "Content-driven outreach for link building.",
        ],
      },
      {
        type: "p",
        text: "The result: 100% visibility and reach for all content produced—more traffic, more shares, and more leads for the same content spend.",
      },

      { type: "h3", text: "What if you were to not invest in content marketing?" },
      {
        type: "ol",
        items: [
          "Without a consistent content strategy, rankings will drop and competitors will steal the traffic (and customers) from you, and you won't even realize it!",
          "If they don't see useful and credible content from you, they won't buy from you.",
          "High cost of paid ads—the traffic dries up if there is no organic content.",
          "Low brand authority – with content, you are the obvious expert; without it, you are just another choice.",
          "Brief customers' relationships—content helps to retain customers between purchases.",
        ],
      },

      { type: "h3", text: "Our Content Marketing Process" },
      {
        type: "ol",
        items: [
          "Discovery & Audit—knowing your business, your audience, and your content assets.",
          "Content Strategy—creating a content strategy that encompasses the whole plan",
          "Researching Keywords & Topics—finding out what your audience is looking for specifically.",
          "Content Creation — writing, designing, and producing quality content assets",
          "SEO Optimization — Optimizing all content to be seen by search engines",
          "Publishing & Distribution—reaching the right people with your content",
          "Performance tracking is the process of tracking results against well-defined KPIs (key performance indicators).",
          "Continuous Optimization—making constant improvements based on data and insights",
        ],
      },

      { type: "h3", text: "Why Ad Hawk Technologies is the best choice for Content Marketing?" },
      {
        type: "ul",
        items: [
          "Always start with strategy first—each piece of content has a business objective.",
          "Quality over quantity—we would rather produce 10 great pieces than 100 mediocre pieces.",
          "Built-in from the ground up, not as an add-on.",
          "Consistency of brand voice—each piece sounds distinctly like you.",
          "Full-service capability: strategy, writing, design, and distribution in one place",
          "Transparency reporting – you’ll always know what your content is doing for your business.",
        ],
      },

      { type: "h3", text: "Looking to have content become your greatest asset for growth?" },
      {
        type: "p",
        text: "When you're ready to develop a content marketing program that will help you achieve real, sustainable organic growth for your business—we're here to help. Let's make your content engine with me.",
      },
    ],
    offers: [
      "Content strategy & planning (research, calendar, KPI benchmarking)",
      "Optimized blog writing & long form articles for SEO.",
      "Website copywriting—home, about, service pages, landing pages",
      "Creating social media content (platform-native formats)",
      "Concepts and script writing—short and long-form video",
      "Design and produce infographics and visual content. Create infographics and visual content.",
      "Lead magnet content, white papers, and case studies.",
      "Email newsletters and content recycling",
      "Content distribution & promotion (SEO + amplification)",
    ],
    benefits: [
      "Generates organic traffic and sustainable SEO gains",
      "Builds credibility and trust with your market",
      "Produces qualified leads at a lower acquisition cost",
      "Supports every stage of your funnel",
      "Delivers compounding ROI long after publishing",
    ],
  },
  {
    key: "branding",
    icon: "Brand",
    title: "Branding",
    image: images.services.branding,
    headline: "Build a Brand That People Remember, Trust, and Choose",
    intro:
      "If your brand doesn’t communicate your value clearly and consistently, you’re invisible to the people who need you most. We help you define, design, and position your brand to win.",
    description: [
      "At Ad Hawk Technologies, we help businesses build powerful, memorable brand identities—from strategy to identity design and messaging. We go beyond “a logo” to define who you are, what you stand for, and why the right customers should choose you over everyone else.",
      "People don’t just buy products—they buy brands they trust. We build that trust with clarity, consistency, and a brand experience that looks and feels premium across every touchpoint.",
    ],
    content: [
      {
        type: "p",
        text: "Your business might have the best product or service in the market. But if your brand doesn't communicate that clearly and consistently, you're invisible to the people who need you most.",
      },
      {
        type: "p",
        text: "At Ad Hawk Technologies, we're a full-service branding agency that helps businesses build powerful, memorable brand identities from the ground up — or refresh and reposition existing ones. We go far beyond designing a logo. We help you define who you are, what you stand for, and why your ideal customers should choose you over everyone else.",
      },
      {
        type: "p",
        text: "Because here's the truth: people don't just buy products — they buy brands they trust.",
      },
      { type: "h3", text: "What Is Branding and Why Does It Matter?" },
      {
        type: "p",
        text: "Branding is the complete perception your audience has of your business. It's your visual identity, your voice, your values, your promise — and the feeling people get every single time they interact with you.",
      },
      {
        type: "p",
        text: "Strong branding does several things that no ad campaign can replicate on its own:",
      },
      {
        type: "ul",
        items: [
          "It creates instant recognition — people know it's you before they even read your name",
          "It builds deep trust — consistent brands feel reliable and professional",
          "It commands premium pricing — strong brands justify higher prices effortlessly",
          "It drives loyalty — customers return to brands they feel connected to",
          "It attracts the right audience — clarity in branding filters out the wrong leads and draws in the right ones",
        ],
      },
      {
        type: "p",
        text: "Whether you're launching a new business or evolving an established one, investing in professional branding is one of the highest-ROI decisions you can make.",
      },
      { type: "h3", text: "Our Branding Services" },

      { type: "h4", text: "01. Brand Strategy & Positioning" },
      {
        type: "p",
        text: "Before we design anything, we think. A beautiful logo means nothing without a solid strategic foundation behind it. Brand strategy is the blueprint that guides every creative and business decision you make going forward.",
      },
      {
        type: "p",
        text: "What we offer:",
      },
      {
        type: "ul",
        items: [
          "Brand discovery workshops and stakeholder interviews",
          "Mission, vision, and core values development",
          "Unique value proposition (UVP) crafting",
          "Competitive landscape analysis",
          "Brand positioning and messaging strategy",
          "Target audience profiling and persona development",
        ],
      },
      {
        type: "p",
        text: "The result: A crystal-clear brand strategy that aligns your entire team and gives every future decision a strong, consistent direction.",
      },

      { type: "h4", text: "02. Brand Identity Design" },
      {
        type: "p",
        text: "Your brand identity is how your business looks, feels, and presents itself to the world. It's the visual language that communicates your personality and values at a glance — before a single word is read.",
      },
      { type: "p", text: "What we offer:" },
      {
        type: "ul",
        items: [
          "Logo design and variations (primary, secondary, icon)",
          "Color palette development with psychological intent",
          "Typography selection and type hierarchy",
          "Custom iconography and graphic elements",
          "Brand pattern and texture design",
          "Business card, letterhead, and stationery design",
        ],
      },
      {
        type: "p",
        text: "The result: A visually powerful brand identity that looks professional, feels authentic, and is instantly recognizable wherever it appears.",
      },

      { type: "h4", text: "03. Brand Voice & Messaging" },
      {
        type: "p",
        text: "How your brand sounds is just as important as how it looks. Your brand voice — the tone, language, and personality you communicate with — shapes how people feel about your business and whether they feel connected to it.",
      },
      { type: "p", text: "What we offer:" },
      {
        type: "ul",
        items: [
          "Brand tone of voice guidelines",
          "Core messaging framework and brand story",
          "Tagline and slogan development",
          "Website and marketing copy in your brand voice",
          "Brand messaging for different audience segments",
          "Do's and don'ts communication guide",
        ],
      },
      {
        type: "p",
        text: "The result: A consistent, compelling brand voice that connects emotionally with your audience and makes everything you communicate feel unmistakably yours.",
      },

      { type: "h4", text: "04. Logo Design & Visual Identity" },
      {
        type: "p",
        text: "Your logo is the face of your brand — the single image that carries the weight of everything your business represents. A great logo is simple, versatile, memorable, and deeply intentional.",
      },
      { type: "p", text: "What we offer:" },
      {
        type: "ul",
        items: [
          "Custom logo design from concept to final delivery",
          "Multiple concept exploration and creative directions",
          "Responsive logo variations for different use cases",
          "Full logo files in all formats (SVG, PNG, PDF, EPS)",
          "Dark, light, and monochrome versions",
          "Usage guidelines for consistent application",
        ],
      },
      {
        type: "p",
        text: "The result: A logo you're genuinely proud of — one that communicates your brand's essence instantly and looks stunning everywhere it appears.",
      },

      { type: "h4", text: "05. Brand Guidelines & Style Guide" },
      {
        type: "p",
        text: "Consistency is the foundation of a strong brand. Once we've built your brand identity, we document everything in a comprehensive brand guidelines document that ensures your brand looks and sounds the same everywhere.",
      },
      { type: "p", text: "What we offer:" },
      {
        type: "ul",
        items: [
          "Logo usage rules and spacing guidelines",
          "Primary and secondary color palette with hex, RGB, and CMYK values",
          "Typography system with hierarchy and usage rules",
          "Imagery and photography style guidelines",
          "Tone of voice and writing style rules",
          "Social media and digital asset guidelines",
          "Dos and don'ts with real examples",
        ],
      },
      {
        type: "p",
        text: "The result: A brand that stays consistent, professional, and recognizable across every channel — no matter who's creating the content.",
      },

      { type: "h4", text: "06. Brand Naming" },
      {
        type: "p",
        text: "The right name can make your brand unforgettable. The wrong one can silently hold your business back for years.",
      },
      { type: "p", text: "What we offer:" },
      {
        type: "ul",
        items: [
          "Creative brand naming workshops",
          "Name concept development across multiple directions",
          "Domain and trademark availability screening",
          "Linguistic and cultural suitability review",
          "Short-list refinement and final recommendation",
        ],
      },
      {
        type: "p",
        text: "The result: A powerful, ownable brand name that sets the right tone, sticks in people's minds, and opens doors from day one.",
      },

      { type: "h4", text: "07. Rebranding" },
      {
        type: "p",
        text: "Markets change. Businesses evolve. And sometimes, your brand simply no longer reflects who you are or where you're headed.",
      },
      { type: "p", text: "What we offer:" },
      {
        type: "ul",
        items: [
          "Brand audit and gap analysis",
          "Competitive repositioning strategy",
          "Updated visual identity and logo redesign",
          "Revised messaging and tone of voice",
          "Internal and external rebrand rollout planning",
          "Stakeholder communication and launch strategy",
        ],
      },
      {
        type: "p",
        text: "The result: A refreshed, future-ready brand that better represents your business today — and positions you powerfully for where you're going tomorrow.",
      },

      { type: "h4", text: "08. Packaging & Collateral Design" },
      {
        type: "p",
        text: "Your brand doesn't live only on screens. It lives on packaging, brochures, signage, presentations, uniforms, and every physical touchpoint your customers experience.",
      },
      { type: "p", text: "What we offer:" },
      {
        type: "ul",
        items: [
          "Product packaging design",
          "Brochure, flyer, and catalogue design",
          "Presentation and pitch deck design",
          "Trade show and event collateral",
          "Signage and environmental branding",
          "Branded merchandise and promotional materials",
        ],
      },
      {
        type: "p",
        text: "The result: A cohesive brand experience that impresses customers at every touchpoint — online and offline.",
      },

      { type: "h3", text: "The Consequences of Weak Branding" },
      {
        type: "p",
        text: "Many businesses underestimate the damage that inconsistent or poor branding quietly does over time. Here's what's really at stake:",
      },
      {
        type: "ol",
        items: [
          "You blend in instead of standing out — in a crowded market, a weak brand is invisible.",
          "You attract the wrong customers — unclear branding sends mixed signals and wastes resources.",
          "You can't charge what you're worth — strong brands compete on value, not price.",
          "Your team lacks direction — without a clear identity, consistency breaks internally and externally.",
          "Growth stalls — weak branding makes trust take longer and marketing work harder for less.",
        ],
      },

      { type: "h3", text: "Our Branding Process" },
      {
        type: "ol",
        items: [
          "Discovery & Research — deep dive into your business, audience, and competitive landscape",
          "Brand Strategy Development — defining your positioning, messaging, and brand personality",
          "Creative Exploration — developing multiple visual and verbal directions for your brand",
          "Design & Refinement — bringing the chosen direction to life with precision and polish",
          "Brand Guidelines Creation — documenting everything for consistent, long-term application",
          "Launch Support — helping you roll out your new brand with confidence and impact",
        ],
      },

      { type: "h3", text: "Why Choose Ad Hawk Technologies for Branding?" },
      {
        type: "p",
        text: "We're not just designers — we're brand builders. Every project we take on is driven by strategy first and creativity second, because beautiful design without strategic intent is just decoration.",
      },
      {
        type: "ul",
        items: [
          "Strategy-led creativity — every design decision is rooted in your brand strategy and business goals",
          "Collaborative process — we work with you, not just for you, at every stage",
          "End-to-end capability — from naming and strategy to identity design and brand guidelines, everything under one roof",
          "Industry versatility — we’ve built and refreshed brands across retail, technology, hospitality, healthcare, eCommerce, and more",
          "Long-term thinking — we build brands designed to grow and evolve with your business, not just look good today",
        ],
      },

      { type: "h3", text: "Ready to Build a Brand That Works as Hard as You Do?" },
      {
        type: "p",
        text: "Your brand is your most valuable long-term business asset. It's what people say about you when you're not in the room. It's the reason someone chooses you over a cheaper competitor. It's the foundation everything else in your marketing is built on.",
      },
      {
        type: "p",
        text: "If you're ready to invest in a brand that truly represents your business, resonates with your audience, and drives real commercial results — we're ready to build it with you. Let's create something extraordinary together.",
      },
    ],
    offers: [
      "Brand strategy & positioning (UVP, audience, competitive analysis)",
      "Brand identity design (visual system, typography, palette, icons)",
      "Brand voice & messaging (story, framework, tone guidelines)",
      "Logo design + responsive variations + usage rules",
      "Brand guidelines & style guide for consistency",
      "Rebranding & repositioning strategy",
      "Packaging & collateral design (digital + print assets)",
    ],
    benefits: [
      "Instant recognition and stronger trust",
      "Clear positioning that attracts the right customers",
      "Higher perceived value (supports premium pricing)",
      "Consistent brand experience across channels",
      "A foundation that makes marketing more effective",
    ],
  },
];

export function getServiceByKey(key) {
  return servicesData.find((s) => s.key === key);
}

